import React from 'react'
import PlaceholderImage from 'components/PlaceholderImage'

import './ResultCard.scss'

export const ResultCard = ({
  id = `0`,
  url,
  imageUrl,
  label,
  onClick = function (id, url) {},
  buttonText = 'Learn More',
}) => (
  <div className={`grocery-result-card`}>
    {url && imageUrl && (
      <a
        href={url}
        target="_blank"
        onClick={() => {
          onClick(id, url)
        }}
        className="card-image"
      >
        <div className="img">
          <PlaceholderImage src={imageUrl} height={200} width={300} />
        </div>
      </a>
    )}
    <div className="referral-bottom">
      {label && (
        <div className="label" dangerouslySetInnerHTML={{ __html: label }} />
      )}

      {url && (
        <a
          href={url}
          target="_blank"
          className="card-btn themed-button"
          onClick={() => {
            onClick(id, url)
          }}
        >
          {buttonText}
        </a>
      )}
    </div>
  </div>
)

export default ResultCard
